import {
	AfterViewInit,
	ChangeDetectionStrategy,
	Component,
	DestroyRef,
	inject,
	OnInit,
	Renderer2,
} from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { ActivatedRoute, Router } from "@angular/router";
import { Store } from "@ngxs/store";
import { fromEvent } from "rxjs";
import { debounceTime, filter, tap } from "rxjs/operators";
import { environment } from "../environments/environment";
import { PwaService } from "./pages/pwa-install-prompt/pwa.service";
import { TitleService } from "./shared/service/title.service";
import { UpdateWindowInfoAction } from "./shared/state/layout.actions";
import { setWindowInfo } from "./shared/state/layout.state";
import { ConfigureAsKiosk } from "./sign-in-kiosk/state/sign-in-kiosk.actions";
import { SignInKioskState } from "./sign-in-kiosk/state/sign-in-kiosk.state";

@Component({
	selector: "app-root",
	templateUrl: "./app.component.html",
	styleUrls: ["./app.component.css"],
	standalone: false,
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements AfterViewInit, OnInit {
	isMultiColorActive = environment.isMultiColorActive;
	private titleService: TitleService = inject(TitleService);
	private renderer: Renderer2 = inject(Renderer2);
	private store: Store = inject(Store);
	private destroyRef: DestroyRef = inject(DestroyRef);
	private router: Router = inject(Router);
	private aRoute: ActivatedRoute = inject(ActivatedRoute);
	private pwaService: PwaService = inject(PwaService);

	ngOnInit() {
		this.titleService.init();

		// Log version information in development mode
		console.log(`App Version: ${environment.version}`);

		fromEvent(window, "resize")
			.pipe(
				debounceTime(100),
				takeUntilDestroyed(this.destroyRef),
				tap((event) => {
					const { target } = event;

					const { outerHeight, outerWidth } = target as Window;
					this.store.dispatch(
						new UpdateWindowInfoAction(
							setWindowInfo(outerHeight, outerWidth),
						),
					);
				}),
			)
			.subscribe();

		if (this.pwaService.isInPwaMode()) {
			this.aRoute.queryParams
				.pipe(
					takeUntilDestroyed(this.destroyRef),
					filter(
						(params) =>
							Object.keys(params).includes("wpa-app") &&
							Object.keys(params).includes("type"),
					),
				)
				.subscribe((params) => {
					switch (params.type) {
						case "sign-in-kiosk": {
							const { slug } = params;
							const signInKioskSlug = this.store.selectSnapshot(
								SignInKioskState.SignInKioskSlug,
							);
							if (!signInKioskSlug) {
								this.store.dispatch(
									new ConfigureAsKiosk({
										slug,
										redirect: true,
									}),
								);
							}
							this.router.navigate(["/sign-in-kiosk"], {
								queryParamsHandling: "merge",
							});
							break;
						}
					}
				});
		}
	}

	ngAfterViewInit() {
		setTimeout(() => {
			this.renderer.addClass(document.body, "show");
		}, 1000);
		setTimeout(() => {
			this.renderer.addClass(document.body, "default-transition");
		}, 1500);
	}
}
